const availableAnimations = {
    bounces: {
        bounce: 'bounce',
        bounceIn: 'bounceIn',
        bounceInDown: 'bounceInDown',
        bounceInLeft: 'bounceInLeft',
        bounceInRight: 'bounceInRight',
        bounceInUp: 'bounceInUp',
        bounceOut: 'bounceOut',
        bounceOutDown: 'bounceOutDown',
        bounceOutLeft: 'bounceOutLeft',
        bounceOutRight: 'bounceOutRight',
        bounceOutUp: 'bounceOutUp',
    },
    fades: {
        fadeIn: 'fadeIn',
        fadeInDown: 'fadeInDown',
        fadeInDownBig: 'fadeInDownBig',
        fadeInLeft: 'fadeInLeft',
        fadeInLeftBig: 'fadeInLeftBig',
        fadeInRight: 'fadeInRight',
        fadeInRightBig: 'fadeInRightBig',
        fadeInUp: 'fadeInUp',
        fadeInUpBig: 'fadeInUpBig',
        fadeOut: 'fadeOut',
        fadeOutDown: 'fadeOutDown',
        fadeOutDownBig: 'fadeOutDownBig',
        fadeOutLeft: 'fadeOutLeft',
        fadeOutLeftBig: 'fadeOutLeftBig',
        fadeOutRight: 'fadeOutRight',
        fadeOutRightBig: 'fadeOutRightBig',
        fadeOutUp: 'fadeOutUp',
        fadeOutUpBig: 'fadeOutUpBig',
    },
    flips: {
        flipInX: 'flipInX',
        flipInY: 'flipInY',
        flipOutX: 'flipOutX',
        flipOutY: 'flipOutY',
    },
    rotations: {
        rotateIn: 'rotateIn',
        rotateInDownLeft: 'rotateInDownLeft',
        rotateInDownRight: 'rotateInDownRight',
        rotateInUpLeft: 'rotateInUpLeft',
        rotateInUpRight: 'rotateInUpRight',
        rotateOut: 'rotateOut',
        rotateOutDownLeft: 'rotateOutDownLeft',
        rotateOutDownRight: 'rotateOutDownRight',
        rotateOutUpLeft: 'rotateOutUpLeft',
        rotateOutUpRight: 'rotateOutUpRight',
    },
    zooms: {
        zoomIn: 'zoomIn',
        zoomInDown: 'zoomInDown',
        zoomInLeft: 'zoomInLeft',
        zoomInRight: 'zoomInRight',
        zoomInUp: 'zoomInUp',
        zoomOut: 'zoomOut',
        zoomOutDown: 'zoomOutDown',
        zoomOutLeft: 'zoomOutLeft',
        zoomOutRight: 'zoomOutRight',
        zoomOutUp: 'zoomOutUp',
    },
    slides: {
        slideInDown: 'slideInDown',
        slideInLeft: 'slideInLeft',
        slideInRight: 'slideInRight',
        slideInUp: 'slideInUp',
        slideOutDown: 'slideOutDown',
        slideOutLeft: 'slideOutLeft',
        slideOutRight: 'slideOutRight',
        slideOutUp: 'slideOutUp',
    },
    misc: {
        flash: 'flash',
        pulse: 'pulse',
        rubberBand: 'rubberBand',
        shake: 'shake',
        headShake: 'headShake',
        swing: 'swing',
        tada: 'tada',
        wobble: 'wobble',
        jello: 'jello',
        lightSpeedIn: 'lightSpeedIn',
        lightSpeedOut: 'lightSpeedOut',
        hinge: 'hinge',
        jackInTheBox: 'jackInTheBox',
        rollIn: 'rollIn',
        rollOut: 'rollOut',
        heartBeat: 'heartBeat'
    }
};

const animationEvents = [
    {
        eventType: 'animationend',
        eventCallback: (e) => {
            e.target.classList.remove('animated');
            e.target.classList.remove(e.animationName);
        }
    }
];

const animation = {
    addAnimation: (element, animationType, animationDuration = null, events = null) => {
        if (animationDuration) {
            element.style.animationDuration = animationDuration;
        }

        if (events) {
            try {
                events = events.concat(animationEvents);
            } catch (e) {
                new Error("events is probably not an array" + e);
            }

        } else {
            events = animationEvents;
        }

        events.forEach(animationEvent => {
            element.addEventListener(animationEvent.eventType, animationEvent.eventCallback, {once: true});
        });

        element.classList.add('animated');
        element.classList.add(animationType);
    }
};

export { availableAnimations, animation }
